import * as is from 'is';

/**
 * Returns true if the given value represents an affirmative ("yes", "true", "on").
 * Returns `defaultValue` when value is null or undefined.
 *
 * @param {*} value The value to test.
 * @param {boolean} [defaultValue=true] Fallback when value is nil/undefined.
 * @returns {boolean}
 */
export function isYesValue(value, defaultValue = true) {
  if (is.nil(value) || is.undef(value)) {
    return defaultValue;
  }
  return [
    'true',
    'on',
    'yes',
  ].includes(String(value).toLowerCase());
}
